// Check for css when change
export const ID_DIV_STRIP_RHYTHM_EVENT = 'stripEventsRhythmEvents';
